__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/ff287ed0637197ac3167bc9b533c5483657c8005/_next/";